import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export const CustomerLoginHeader: FC = () => {
  return (
    <Stack alignItems="center" gap={2}>
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│顧客環境ログイン
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
